// Lightweight AsyncStorage shim for web builds.
// Uses localStorage under the hood and matches the async API surface.
const AsyncStorage = {
  async getItem(key) {
    try {
      const v = localStorage.getItem(key);
      return v;
    } catch (e) {
      return null;
    }
  },
  async setItem(key, value) {
    try {
      localStorage.setItem(key, String(value));
      return null;
    } catch (e) {
      throw e;
    }
  },
  async removeItem(key) {
    try {
      localStorage.removeItem(key);
      return null;
    } catch (e) {
      throw e;
    }
  },
  async getAllKeys() {
    try {
      return Object.keys(localStorage);
    } catch (e) {
      return [];
    }
  }
};

export default AsyncStorage;
